<header [ngClass]="{'brand-tracker':pageTitle.toLowerCase()==='brand tracker'}">
  <!--<div class="logo" [routerLink]="['./']">-->
  <div class="logo" (click)="navigateToMainPage()">
    <img id="brandLogo" [src]="imageSrc" alt="accesshublogo">
  </div>

  <div class="header-channel-box" *ngIf="!isHomeComponent()" #channelNavigator="ngbDropdown" ngbDropdown>
    <h4 ngbDropdownToggle>
      <span class="channel-name">{{pageTitle}}</span>
      <span class="filter-summary" *ngIf="tasFilterCountResume >= 0 || assetsFilterCountResume >= 0 || indicationsFilterCountResume >= 0">
        {{generalService?.appliedFiltersSummary}}
      </span>
      <!-- <span class="filter-summary" *ngIf="tasFilterCountResume >= 0 || assetsFilterCountResume >= 0 || indicationsFilterCountResume >= 0">
        <ng-container *ngIf="tasFilterCountResume >= 0">{{tasFilterText}}</ng-container>
        <ng-container *ngIf="tasFilterCountResume > 0">+{{tasFilterCountResume}}</ng-container>
        <span class="separator" *ngIf="tasFilterCountResume >= 0 && (assetsFilterCountResume >= 0 || indicationsFilterCountResume >= 0)"></span>
        <ng-container *ngIf="assetsFilterCountResume >= 0">{{assetsFilterText}}</ng-container>
        <ng-container *ngIf="assetsFilterCountResume > 0">+{{assetsFilterCountResume}}</ng-container>
        <span class="separator" *ngIf="assetsFilterCountResume >= 0 && indicationsFilterCountResume >= 0"></span>
        <ng-container *ngIf="indicationsFilterCountResume >= 0">{{indicationsFilterText}}</ng-container>
        <ng-container *ngIf="indicationsFilterCountResume > 0">+{{indicationsFilterCountResume}}</ng-container>
      </span> -->
    </h4>
    <div ngbDropdownMenu>
      <app-channel-navigator></app-channel-navigator>
    </div>

  </div>


  <div class="search-header">

    <div class="header-search-btn">
      <button class="blank-btn" [ngClass]="{'has-filter' : appliedAdvancedSearchFilter }" #searchPopover="ngbPopover" [ngbPopover]="searchPopContent"
        [popoverTitle]="searchPopTitle" [autoClose]="'outside'">
        <i class="icon-search-filter"> </i>
      </button>
      <ng-template #searchPopTitle>
        <div class="popover-search-head">
          <h2>Advanced Search</h2>
          <p>Narrow your keyword search by selecting context...</p>
        </div>
      </ng-template>
      <ng-template #searchPopContent>
        <div class="popover-search-body">
          <h6>Channel</h6>
          <ng-select class="MB12" [(ngModel)]="advancedSearchFilter.ChannelTitle" [items]="channelOptions" bindLabel="Title" bindValue="Title"
            placeholder="Select an option" [clearable]="false" dropdownPosition="bottom"></ng-select>

          <div class="d-inline-block ML0 W150" ngbDropdown #dropTAs="ngbDropdown">
            <h6>TA</h6>
            <ng-select class="drop180" (change)="taChanged($event)" [(ngModel)]="advancedSearchFilter.TA" [items]="taOptions" bindLabel="Title"
              bindValue="Title" placeholder="Select an option" [clearable]="false" dropdownPosition="bottom"></ng-select>
          </div>

          <div class="d-inline-block ML15 W150" ngbDropdown #dropAssets="ngbDropdown">
            <h6>Asset</h6>
            <ng-select class="drop180" [(ngModel)]="advancedSearchFilter.Asset" [items]="assetOptions" bindLabel="Title" bindValue="Title"
              placeholder="Select an option" [clearable]="false" dropdownPosition="bottom"></ng-select>
          </div>

          <div class="d-inline-block ML15 W150" ngbDropdown #dropIndications="ngbDropdown">
            <h6>Indication</h6>
            <ng-select class="drop180" [(ngModel)]="advancedSearchFilter.Indication" [items]="indicationOptions" bindLabel="Title" bindValue="Title"
              placeholder="Select an option" [clearable]="false" dropdownPosition="bottom"></ng-select>
          </div>

          <div class="popover-search-footer">
            <button class="primary-button" (click)="applyAdvancedSearchFilter(searchPopover)">Apply</button>
            <button class="ML10" (click)="resetAdvancedSearchFilter()">Reset</button>
          </div>
        </div>
      </ng-template>
    </div>
    <input class="search-header-input" type="text" (keypress)="searchKeyPress($event, searchPopover)" placeholder="Search" [(ngModel)]="queryText">
    <button class="blank-btn" (click)="goToSearch(searchPopover)">
      <i class="icon icon-search"></i>
    </button>
  </div>
  <ng-container *ngIf="isAuthenticated">
    <div class="header-user">
      <i class="header-user-icon"></i>
      <p>{{activeAccount?.name}}</p>
      <span>{{activeAccount?.username}}</span>
      <button *ngIf="isSignoutVisible" (click)="signOut()">
        <i class="header-icon-logout"></i>
      </button>
    </div>
  </ng-container>
  <ng-container>
    <div class="cursor" style="float: right; margin-top: 20px; margin-right: 12px;font-size: 16px; font-weight: 600;">
      <img title="Glossary" class="glossaryBtn" (click)="navigateToTaxonomy()" src="assets/img/book-icon-web.jpg"
        alt="Book icon web" width="38" height="38">
    </div>
  </ng-container>
</header>
<!-- *ngIf="!this.router.url.includes('glossary')" -->